import {
  CUSTOM_TAX_RATE,
  EAgentClientSigningBasis,
  TAX_RATE_OPTIONS,
} from 'src/containers/LeadCompanyClients';
import {EResellerIds} from 'src/containers/User';
import {joiResolver} from 'src/utils';
import {joi as Joi} from 'src/utils/validator';

const signingBasisWithDetails = [
  EAgentClientSigningBasis.ENTRUSTMENT,
  EAgentClientSigningBasis.ORDER,
  EAgentClientSigningBasis.CERTIFICATE,
];

export const editFields = {
  companyName: Joi.string().trim().required(),
  taxRate: Joi.required(),
  customTaxRate: Joi.when('taxRate', {
    is: CUSTOM_TAX_RATE,
    then: Joi.number()
      .required()
      .when('resellerId', {
        not: EResellerIds.OSK_ID,
        then: Joi.custom((value, helpers) => {
          const resellerId = helpers.state.ancestors[0].resellerId as EResellerIds;
          const options = TAX_RATE_OPTIONS[resellerId]!.AGENT_AGREEMENT.filter(
            (option) => typeof option === 'number',
          );

          if (options.includes(value / 100)) {
            return helpers.error('^AgentCompanyClients:errors.invalidTaxRate', {value});
          }

          return value;
        }),
      }),
  }),
  signingBasis: Joi.required(),
  signingBasisDate: Joi.when('signingBasis', {
    is: signingBasisWithDetails,
    then: Joi.date().required(),
  }),
  signingBasisNumber: Joi.when('signingBasis', {
    is: signingBasisWithDetails,
    then: Joi.string().required(),
  }),
  signatoryLastName: Joi.string().trim().required(),
  signatoryFirstName: Joi.string().trim().required(),
};

export const resolver = joiResolver((joi, mixed) =>
  joi.object({
    ...editFields,
    agentName: joi.string().trim().required(),
    taxNumber: joi.string().required(),
    phone: joi.number().required(),
    email: mixed.email.required(),
    resellerId: joi.required(),
    contactName: joi.string().trim().required(),
    responsibleManagerId: joi.required(),
  }),
);
